import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import s from './input.module.css';
var inputMargin = 4;
var additionsMargin = 8;
var padding = 16;
var Label = function Label(_ref) {
  var container = _ref.container,
    size = _ref.size,
    content = _ref.content,
    info = _ref.info,
    reset = _ref.reset,
    postfix = _ref.postfix,
    children = _ref.children,
    id = _ref.id,
    required = _ref.required,
    status = _ref.status;
  var _useState = useState({
      start: padding,
      end: padding
    }),
    _useState2 = _slicedToArray(_useState, 2),
    restrictions = _useState2[0],
    setRestriction = _useState2[1];
  var getAdditions = useCallback(function () {
    var _a;
    return Array.from(((_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-addon-end]')) || []);
  }, [container]);
  useEffect(function () {
    if (size !== 'l') {
      return;
    }
    var additions = getAdditions();
    var width = additions.reduce(function (res, node) {
      return res + node.offsetWidth;
    }, 0);
    var restriction = padding + width + ((additions.length - 1) * additionsMargin + Math.sign(additions.length) * inputMargin);
    setRestriction(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        end: restriction
      });
    });
  }, [status.icon, content.end, info, reset, size, postfix, getAdditions]);
  useEffect(function () {
    var _a, _b;
    if (size !== 'l') {
      return;
    }
    var width = ((_b = (_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-addon-start]')) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
    var restriction = padding + width;
    setRestriction(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        start: restriction
      });
    });
  }, [content.start, size, container]);
  return React.createElement("label", {
    htmlFor: id,
    className: classNames(s.label, size === 'l' ? s.inside : s.outside, required && s.required),
    style: Object.assign({}, size === 'l' && {
      left: restrictions.start,
      right: restrictions.end
    })
  }, React.createElement("span", {
    className: s.labeltext
  }, children), required && React.createElement("div", {
    className: s.star
  }, "*"));
};
export default Label;